import Bar from './bar';

export default Bar;